import React, { useContext } from 'react';
import { Popover, Button } from '@milanote/roma';
import { OverlayTriggerStateContext } from 'react-aria-components';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type Props = {
    onDelete: () => void;
};

const LabelListDeletePopover = ({ onDelete }: Props) => {
    const deletePopoverState = useContext(OverlayTriggerStateContext);
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <Popover.Body className="py-2xl px-2xl">
            <div className="flex flex-col gap-xl">
                <p className="text-center text-md text-secondary">{translate('deleteDescription')}</p>

                <div className="flex gap-3">
                    <Button color="secondary" size="md" className="flex-1" onClick={() => deletePopoverState?.close()}>
                        {translate('deleteCancel')}
                    </Button>
                    <Button color="primary-destructive" size="md" className="flex-1" onClick={onDelete}>
                        {translate('deleteConfirm')}
                    </Button>
                </div>
            </div>
        </Popover.Body>
    );
};

export default LabelListDeletePopover;
